// MOBILE MEGA MENU AND DROPDOWN MENU FUNCTIONALITY

const body = document.body;
const mobileMegaMenuContainers = body.querySelectorAll(
	".li-container.mobile.mega-menu-mob-container",
);
const mobileCountriesSelector = body.querySelectorAll(
	".countriesSelector",
);
const mobileMegaMenuBackButtons = body.querySelectorAll(".back-button-mm-mob");
const wishlistLoginContainer = body.querySelector(".wishlist-login-container");
const mobileDropDownMenuHeaders = body.querySelectorAll(
	".dropdown-header-mobile",
);
const mobileDropDownBackButtons = body.querySelectorAll(".back-button-dd-mob");

const toggleWishlistContainer = (hide) => {
	setTimeout(
		() => wishlistLoginContainer.classList.toggle("hidden", hide),
		100,
	);
};

for (const container of mobileMegaMenuContainers) {
	const menuTitles = container.querySelectorAll(".mm-mobile-menu-title");

	for (const menuTitle of menuTitles) {
		const crossContainer = menuTitle.querySelector(".cross-container");
		const menuLinks = menuTitle.nextElementSibling;

		menuTitle.addEventListener("click", () => {
			for (const otherTitle of menuTitles) {
				if (otherTitle !== menuTitle) {
					otherTitle
						.querySelector(".cross-container")
						.classList.remove("collapsed");
					otherTitle.nextElementSibling.classList.add("hidden");
				}
			}
			crossContainer.classList.toggle("collapsed");
			menuLinks.classList.toggle("hidden");
		});
	}

	const header = container.querySelector(".mega-menu-mob-title");
	header.addEventListener("click", (e) => {
		e.preventDefault();
		container
			.querySelector(".mega-menu-mobile-container")
			.classList.add("open");
		toggleWishlistContainer(true);
	});
}

for (const container of mobileCountriesSelector) {
	
	const header = container.querySelector(".mega-menu-mob-title");
	header.addEventListener("click", () => {
		if(document.getElementById("countriesSelection").classList.contains("hidden")){
			document.getElementById("countriesSelection").classList.remove("hidden");
			document.getElementsByClassName("iconCountrySelector")[0].classList.add("fill-highlight-primary-50");
			document.getElementsByClassName("iconCountrySelector")[0].style.transform = "rotateX(180deg)";
		}else{
			document.getElementById("countriesSelection").classList.add("hidden");
			document.getElementsByClassName("iconCountrySelector")[0].classList.remove("fill-highlight-primary-50");
			document.getElementsByClassName("iconCountrySelector")[0].style.transform = "rotateX(360deg)";
		}
	});
}

for (const backButton of mobileMegaMenuBackButtons) {
	backButton.addEventListener("click", (e) => {
		e.preventDefault();
		backButton.closest(".mega-menu-mobile-container").classList.remove("open");
		wishlistLoginContainer.classList.remove("hidden");
	});
}

for (const header of mobileDropDownMenuHeaders) {
	header.addEventListener("click", (e) => {
		e.preventDefault();
		header.nextElementSibling.classList.add("open");
		if (!header.classList.contains("more-info")) {
			toggleWishlistContainer(true);
		}
	});
}

for (const backButton of mobileDropDownBackButtons) {
	backButton.addEventListener("click", (e) => {
		e.preventDefault();
		backButton.closest(".dropdown-menu-mobile").classList.remove("open");
		wishlistLoginContainer.classList.remove("hidden");
	});
}

// ANIMATION OF THE CLOSING OF THE MENU DRAWER
function closeMenuDrawerWithAnimation() {
	const menuDrawer = document.querySelector("#menu-drawer");
	const menuDrawerContainer = document.querySelector(".menu-drawer-container");
	const summary = document.querySelector("summary");
	summary.setAttribute("aria-expanded", "false");

	menuDrawer.animate(
		[
			{
				transform: "translateX(0)",
			},
			{
				transform: "translateX(-100%)",
			},
		],
		{
			duration: 300,
			easing: "ease",
		},
	).onfinish = () => {
		menuDrawerContainer.removeAttribute("open");
		menuDrawer.classList.remove("menu-opening");
		
		// Restore scroll position
		const scrollY = document.body.style.top;
		document.documentElement.style.overflow = '';
		document.documentElement.style.height = '';
		document.body.style.position = "";
		document.body.style.top = "";
		document.body.style.width = '';
		document.body.style.overflowY = '';
		window.scrollTo(0, parseInt(scrollY || "0") * -1);

		const submenuOpenElements =
			menuDrawerContainer.querySelectorAll(".submenu-open");
		submenuOpenElements.forEach(function (submenu) {
			submenu.classList.remove("submenu-open");
		});

		const bodyClassList = document.body.classList;
		const overflowHiddenClass = Array.from(bodyClassList).find((className) =>
			className.startsWith("overflow-hidden-"),
		);
		if (overflowHiddenClass) {
			bodyClassList.remove(overflowHiddenClass);
		}
	};
}

// ADDITION OF CLOSING FUNCTIONALITY TO 'X' IN MENU DRAWER
document.addEventListener("DOMContentLoaded", function () {
	const closeButtons = document.querySelectorAll(".menu-drawer-close-wrapper");
	closeButtons.forEach((button) => {
		button.addEventListener("click", closeMenuDrawerWithAnimation);
	});
});

//ACCOUNT ICON BEHAVIOUR WHEN USER LOGGED IN
document.addEventListener("DOMContentLoaded", function () {
	const dropdownHeaderAccount = document.querySelector(
		".dropdown-header-account",
	);
	const dropdownMenuAccount = document.querySelector(".dropdown-menu-account");

	if (dropdownMenuAccount) {
		const showDropdownMenu = () => {
			dropdownMenuAccount.style.opacity = "1";
			dropdownMenuAccount.style.visibility = "visible";
			dropdownMenuAccount.style.transform = "translate(0px, 0px)";
		};

		const hideDropdownMenu = () => {
			dropdownMenuAccount.style.opacity = "0";
			dropdownMenuAccount.style.visibility = "hidden";
			dropdownMenuAccount.style.transform = "translate(0px, 20px)";
		};

		dropdownHeaderAccount.addEventListener("mouseenter", showDropdownMenu);
		dropdownHeaderAccount.addEventListener("mouseleave", hideDropdownMenu);
		dropdownMenuAccount.addEventListener("mouseenter", showDropdownMenu);
		dropdownMenuAccount.addEventListener("mouseleave", hideDropdownMenu);
	}
});
